import { Link } from "react-router-dom";
import ApplyMembershipModal from "../../components/ApplyMembershipModal";

export default function LandingFooter({ record }) {
  return (
    <footer className="hairline mt-8" style={{ background: "#0B0D0F" }}>
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3">
          <span className="solera-symbol" />
          <span className="wordmark text-bone text-sm">Solera Ventures</span>
        </div>
        <div className="grid md:grid-cols-2 gap-10 mt-8">
          <p className="t-cap text-muted-s" data-testid="footer-compliance-text">
            Solera does not operate an open marketplace. There is no listing, no inventory and
            no public offering of securities. Nothing on this site is an offer to buy or sell
            securities, or a solicitation of one. Directed only to accredited investors in
            jurisdictions where no licence is required to transact in private securities.
          </p>
          <p className="t-cap text-muted-s">
            Solera will never ask you to send funds, account details or identity documents by
            email. This is the only domain we use: solera.vc. If a memo link reaches you from
            anyone other than Solera, it is not from us. Tell us.
          </p>
        </div>
        <div className="hairline mt-10 pt-6 flex items-baseline justify-between gap-6 flex-wrap">
          <span className="t-cap text-muted-s fig">Solera Ventures. Figures as at {record?.as_at || ""}.</span>
          <div className="flex items-center gap-6">
            <Link to="/membership" className="t-label hover:!text-[#E8E6E1]" data-testid="footer-membership-link">Membership</Link>
            <ApplyMembershipModal trigger={
              <button className="t-label hover:!text-[#E8E6E1]" data-testid="footer-apply-link">Apply for membership</button>
            } />
            <Link to="/login" className="t-label hover:!text-[#E8E6E1]" data-testid="footer-login-link">Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
